import { OutliersDataItem } from 'widgets/outliers/data/outliersData';
import { NumberFormat } from '@instinet-analytics/core-lib';
import { linearExtentAdjustedForBubble } from 'widgets/outliers/components/chart/series/bubblesSeries';

export const buildPnlExtent = (
    dataItems: OutliersDataItem[],
    bubbleMaxPx: number,
    lengthPx: number,
    mirror: boolean
) => {
    return linearExtentAdjustedForBubble(
        dataItems,
        'pnl',
        bubbleMaxPx,
        lengthPx,
        mirror
    );
};

export const buildPnlTickFormat = (
    numberFormat: NumberFormat,
    domain: number[]
) => {
    const maxX = Math.abs(domain[1]);
    const minX = maxX * -1;

    return (d: number) => {
        if (d === 0 && minX === 0) {
            return '';
        }
        if (maxX >= 2000000 || minX <= -2000000) {
            return numberFormat.n0(d / 1000000) + 'M';
        }
        if (maxX >= 2000 || minX <= -2000) {
            return numberFormat.n0(d / 1000) + 'K';
        }
        return numberFormat.n0(d);
    };
};
